import { Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DesignSystemModule } from '@peca/design-system';
import { AllowToDirective } from '@peca/keycloak';
import { ConciliationFailure, ConciliationStep } from '../../../../modules/purchases/models/fiscal/inbound-invoice.model';

const CONCILIATION_STEP_LABEL: Record<ConciliationStep, string> = {
  COMMERCE_REFERENCE: 'referência comercial divergente',
  PURCHASE_ORDER_ID_PREFIX: 'prefixo de pedido inválido',
  CNPJ: 'CNPJ divergente',
  FISCAL_ARCHIVED: 'pedido arquivado',
  TOTAL_AMOUNT: 'valor total divergente',
  ITEMS: 'itens divergentes',
};

@Component({
  selector: 'peca-kanban-card-purchase',
  imports: [CommonModule, DesignSystemModule, AllowToDirective],
  templateUrl: './kanban-card-purchase.component.html',
  styleUrl: './kanban-card-purchase.component.scss',
})
export class KanbanCardPurchaseComponent {
  tittle = input<string>('');
  date = input<string>('');
  amount = input<number>(0);
  branchName = input<string>('');
  commerceReference = input<string>('');
  branchDocument = input<string>('');
  withoutRegister = input<boolean>(false);
  conciliationFailure = input<ConciliationFailure | null | undefined>(null);

  hasConciliationFailure = computed(() => !!this.conciliationFailure());
  conciliationFailureTooltip = computed(() => {
    const failure = this.conciliationFailure();
    if (!failure) return '';
    const reason = CONCILIATION_STEP_LABEL[failure.step] ?? failure.step;
    return `Não conciliado por ${reason}`;
  });

  clickRemove = output<void>();
  clickCard = output<void>();
  clickConciliationFailure = output<void>();
  showRemove = input<boolean>(false);
  clickSendOmie = output<void>();
  showSendToOmie = input<boolean>(false);
}
